import { Icon, Typography } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { RubricCategorySchema } from '@scale/shared/pipelinev3/genai';
import { RubricCategory } from '@scale/shared/types/params/textcollection';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface RubricCategoriesBuilderProps {
  name: string;
  existingValue?: Array<RubricCategory>;
  updateProperty: (arg: Array<RubricCategory> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const RubricCategoriesBuilder: React.FC<RubricCategoriesBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const rubricCategories = existingValue || [];
  return (
    <div className="flex flex-col gap-2">
      <Typography.Subtitle3>{name}</Typography.Subtitle3>
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={rubricCategories}
        setElements={updateProperty}
        getKey={rubricCategory => JSON.stringify(rubricCategory)}
        getTitle={rubricCategory => rubricCategory.label || '<New Category>'}
        getSchema={_ => RubricCategorySchema}
      />
      <Icon
        hasBackground
        icon={['fas', 'plus']}
        onClick={() =>
          updateProperty([
            ...rubricCategories,
            {
              value: '',
              label: '',
            },
          ])
        }
        size="md"
        variant="primary"
      />
    </div>
  );
};

export default RubricCategoriesBuilder;
